import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';

const progressCircularRotate = stylex.keyframes({
  '0%': {
    transform: 'rotate(0deg)',
  },
  '100%': {
    transform: 'rotate(360deg)',
  },
});

export const styles = stylex.create({
  base: {
    borderColor: colors.tertiaryBorder,
    backgroundColor: 'transparent',
    animationName: progressCircularRotate,
    animationDuration: '1.4s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear',
    borderRadius: '50%',
    display: 'inline-block',
    padding: '0',
    margin: '0',
    boxSizing: 'border-box',
  },

  small: {
    width: anatomy['size-20'],
    height: anatomy['size-20'],
    border: `1px solid`,
  },

  medium: {
    width: anatomy['size-24'],
    height: anatomy['size-24'],
    border: `2px solid`,
  },

  large: {
    width: anatomy['size-32'],
    height: anatomy['size-32'],
    border: `3px solid`,
  },

  l: {
    width: anatomy['size-64'],
    height: anatomy['size-64'],
    border: `4px solid`,
  },
  accent: { borderBottomColor: colors.accentBackground },
  primary: { borderColor: colors.inverseBorder, borderBottomColor: colors.primaryInverseText },
  secondary: { borderBottomColor: colors.secondaryBackground },
  link: { borderBottomColor: colors.secondaryBackground },
});
